<app-organizer-shared-layout-dashboard
  class="organizer-timeslot-page-manage"
  [hasHeader]="hasHeader"
>
  <app-organizer-shared-header
    class="col-span-12 mb-3 lg:col-span-6"
    [title]="'organizer.manage_timeslot.title' | translate"
    [backLink]="backLink"
    [backLinkAriaLabel]="'a11y.organizer.manage_timeslot.back' | translate"
  >
    <a
      class="flex items-center ml-auto text-vtmn-play-content-brand font-bold"
      [routerLink]="['/attendee.show-activity/', activity?.sku] | localize"
      target="_blank"
      [rel]="'noopener noreferrer'"
    >
      {{ 'editing_activity.preview_button' | translate }}
      <vtmn-play-icon
        class="text-xl ml-1"
        [name]="iconType.ArrowRight"
      ></vtmn-play-icon>
    </a>
  </app-organizer-shared-header>

  <div class="col-span-12 lg:col-start-2 lg:col-span-5 lg:mb-3">
    <app-activity-card
      [activityHasQrcode]="activity?.generateQrcode"
      [picture]="picture"
      [title]="activity?.name"
      [address]="activity?.fullAddress"
      [attendees]="attendees"
      [isLive]="activity?.isLive"
      [price]="timeslot?.minPriceOffer.price"
      [maxPrice]="timeslotOfferMaxPrice"
      [currency]="timeslot?.offers[0]?.currency"
      [variant]="activityCardVariant.SHADOWLESS"
      [visibility]="activity?.visibility"
      [timeslotId]="timeslot?.identifier"
    ></app-activity-card>

    <app-divider
      [variant]="responsiveDividerVariant"
      class="block -mx-3 mb-6 xs:-mx-6 sm:-mx-9 lg:mx-0"
    ></app-divider>

    <app-organizer-shared-edit-section
      [title]="'organizer.manage_timeslot.actions.edit_date.title' | translate"
      [link]="'organizer.timeslot-edition.date' | localize"
    >
      <p>
        <time
          [attr.datetime]="timeslot?.startDate | localizedDate: 'y-MM-dd'"
          >{{ formattedStartDate(timeslot?.startDate) }}</time
        >

        <time [attr.datetime]="timeslot?.startDate | localizedDate: 'HH:mm'">
          - {{ formattedStartTime(timeslot?.startDate) }}
        </time>
      </p>
    </app-organizer-shared-edit-section>

    <ng-container *ngIf="hasGroupSizeSection">
      <app-divider></app-divider>

      <app-organizer-shared-edit-section
        [title]="'organizer.manage_timeslot.maximum_group_size' | translate"
        [link]="'organizer.timeslot-edition.group-size' | localize"
      >
        <p>
          <ng-container *ngIf="!timeslot?.maximumAttendeeCapacity">
            {{ 'organizer.manage_timeslot.to_define' | translate }}
          </ng-container>

          <ng-container *ngIf="timeslot?.maximumAttendeeCapacity">
            {{
              'organizer.manage_timeslot.maximum_group_size_count'
                | translate
                  : {
                      maximumAttendeeCapacity:
                        timeslot?.maximumAttendeeCapacity,
                    }
            }}
          </ng-container>
        </p>
      </app-organizer-shared-edit-section>
    </ng-container>

    <ng-container *ngIf="hasOffersSection">
      <app-divider></app-divider>

      <app-organizer-shared-edit-section
        [title]="
          'organizer.manage_timeslot.actions.edit_offers.title' | translate
        "
        [link]="'organizer.timeslot-edition.offers' | localize"
      >
        <app-organizer-shared-display-plans
          [plans]="timeslot?.offers"
          [displayMode]="
            isBirthday ? displayPlansMode.FULL : displayPlansMode.LIGHT
          "
          [plansMaximumCapacity]="activity?.meta?.plansMaximumCapacity"
        >
        </app-organizer-shared-display-plans>
      </app-organizer-shared-edit-section>
    </ng-container>

    <ng-container *ngIf="activity?.isLive">
      <app-divider></app-divider>

      <app-organizer-shared-edit-live-url-section
        [liveUrl]="timeslot?.liveUrl"
        [noteForAttendees]="timeslot?.noteForAttendees"
        [link]="'organizer.timeslot-edition.live-url' | localize"
      ></app-organizer-shared-edit-live-url-section>
    </ng-container>

    <app-divider
      [variant]="responsiveDividerVariant"
      class="block -mx-3 my-6 xs:-mx-6 sm:-mx-9 lg:mx-0"
    ></app-divider>

    <app-organizer-shared-action-list
      class="block lg:mt-6"
      [title]="'organizer.manage_timeslot.options' | translate"
    >
      <a
        *appListItem
        app-cta
        ctaClass="py-2"
        [variant]="ctaVariant.Link"
        [width]="ctaWidth.Full"
        [leftIconType]="iconType.ListCheck"
        [routerLink]="participantLink | localize"
      >
        {{ 'organizer.manage_timeslot.actions.participant_list' | translate }}
      </a>

      <ng-container *ngIf="!isActivityEvent">
        <a
          *appListItem
          app-cta
          ctaClass="py-2"
          [variant]="ctaVariant.Link"
          [width]="ctaWidth.Full"
          [leftIconType]="iconType.Message"
          [routerLink]="messengingLink | localize"
        >
          {{
            'organizer.manage_timeslot.actions.contact_participants' | translate
          }}
        </a>
      </ng-container>

      <ng-container *ngIf="!activityIsCanceled">
        <a
          *appListItem
          app-cta
          ctaClass="py-2"
          [variant]="ctaVariant.Link"
          [width]="ctaWidth.Full"
          [leftIconType]="iconType.CalendarCheck"
          [routerLink]="'/organizer.activity-planning.activity' | localize"
          [queryParams]="{ activityId: activity?.sku }"
        >
          {{ 'organizer.manage_timeslot.actions.new_dates' | translate }}
        </a>
      </ng-container>

      <ng-container *ngIf="!activityIsCanceled">
        <a
          *appListItem
          app-cta
          ctaClass="py-2"
          [variant]="ctaVariant.Link"
          [width]="ctaWidth.Full"
          [leftIconType]="iconType.Edit"
          [routerLink]="getActivityEditLink(activity?.sku)"
        >
          <span class="flex flex-col">
            <span>
              {{
                'organizer.manage_timeslot.actions.edit_activity.label'
                  | translate
              }}
            </span>
            <span class="text-xs self-start">
              {{
                'organizer.manage_timeslot.actions.edit_activity.description'
                  | translate
              }}
            </span>
          </span>
        </a>
      </ng-container>

      <ng-container *ngIf="isDeletable">
        <button
          app-vtmn-play-button
          type="button"
          *appListItem
          ctaClass="py-2"
          [type]="ctaButtonType.Button"
          [variant]="vtmnPlayButtonVariant.NEGATIVE"
          (click)="openTimeslotDeletionModal()"
        >
          {{ 'organizer.manage_timeslot.actions.delete_date' | translate }}
        </button>
      </ng-container>

      <button
        app-vtmn-play-button
        type="button"
        *appListItem
        class="mt-2"
        ctaClass="py-2"
        [type]="ctaButtonType.Button"
        [variant]="vtmnPlayButtonVariant.SECONDARY"
        (click)="openShareModal()"
      >
        {{ 'organizer.manage_timeslot.actions.share' | translate }}
      </button>
    </app-organizer-shared-action-list>
  </div>
</app-organizer-shared-layout-dashboard>

<app-alert-modal
  #deleteTimeslotWarning
  [confirmLabel]="
    'organizer.manage_timeslot.delete_modal.confirm.button' | translate
  "
  [closeLabel]="
    'organizer.manage_timeslot.delete_modal.abort.button' | translate
  "
  (modalClose)="closeDeleteTimeslotWarningModal()"
  (modalConfirm)="onDeleteConfirm()"
>
  <ng-container modal-header>
    {{ deletionWarningModalTitle | translate }}
  </ng-container>

  <ng-container modal-content>
    {{ 'organizer.manage_timeslot.delete_modal.text' | translate }}
  </ng-container>
</app-alert-modal>

<app-modal-edit-timeslots
  #deleteTimeslotModal
  [isLastTimeslot]="isLastTimeslot"
  [updateMode]="timeslotDeletionModalMode"
  (updateAllTimeslots)="confirmDeleteAllTimeslot()"
  (updateTimeslot)="confirmDeleteTimeslot()"
  (updateSelectedTimeslots)="deleteSelectedTimeslots()"
>
</app-modal-edit-timeslots>

<app-modal
  *ngIf="hasShareModal"
  #shareModal
  (modalClose)="shareModal.hide()"
  [modalVariant]="modalVariant.Secondary"
>
  <div modal-header>
    <p>{{ 'organizer.manage_timeslot.share_modal.title' | translate }}</p>
  </div>

  <div modal-content>
    <app-sharer-buttons [url]="activityUrl"></app-sharer-buttons>
  </div>
</app-modal>

<app-success-overlay
  *ngIf="showDeletionSuccess"
  [successTitle]="
    'organizer.manage_timeslot.deletion.success.title' | translate
  "
  [successDescription]="
    'organizer.manage_timeslot.deletion.success.description' | translate
  "
  [loadingTitle]="
    'organizer.manage_timeslot.deletion.loading.title' | translate
  "
  [loadingDescription]="
    'organizer.manage_timeslot.deletion.loading.description' | translate
  "
  [status]="successStatus"
>
  <button
    app-vtmn-play-button
    type="button"
    [type]="ctaButtonType.Button"
    ctaClass="md:mx-auto"
    (click)="redirectAfterDeletion()"
  >
    {{ 'organizer.manage_timeslot.deletion.button' | translate }}
  </button>
</app-success-overlay>

<app-success-overlay
  *ngIf="showEditionSuccess"
  [successTitle]="'organizer.manage_timeslot.update.success.title' | translate"
  [successDescription]="
    'organizer.manage_timeslot.update.success.description' | translate
  "
  [loadingTitle]="'organizer.manage_timeslot.update.loading.title' | translate"
  [loadingDescription]="
    'organizer.manage_timeslot.update.loading.description' | translate
  "
  [status]="successStatus"
>
  <button
    app-vtmn-play-button
    type="button"
    ctaClass="md:mx-auto"
    [type]="ctaButtonType.Button"
    (click)="hideEditSuccess()"
  >
    {{ 'organizer.manage_timeslot.update.button' | translate }}
  </button>
</app-success-overlay>
